import React, { useCallback } from "react";
import { useTranslation } from "ceco-polyglot";
import useRouter from "found/lib/useRouter";
import { logout } from "../../api/api";
import "./Logout.scss";
export default function Logout(props) {
  const t = useTranslation();
  const { router } = useRouter();
  const clickHandler = useCallback(() => {
    logout().then(() => {
      router.push("/login");
    });
  }, [router]);
  return (
    <div role="button" className="logout" onClick={clickHandler}>
      {t("action.logout")}
    </div>
  );
}
